import React, { Component } from 'react';
import { Button, Form, Grid, Header, Icon, Loader, Popup, Segment, Table } from 'semantic-ui-react';

import axios from 'axios';
import SearchTableData from '../../util/SearchTableData';
import ReportExcelFile from './ReportExcelFile';
import ExcelSheet from 'react-data-export/dist/ExcelPlugin/elements/ExcelSheet';
import { sanitizeExcelDataSet } from '../../util/sanitizeExcel';
import {
    additionalFilterSectionStyle,
    filterFieldGridStyle,
    shouldShowOrgUnitFilter
} from './reportUiHelpers';


class StudentsPerCycle extends Component {
    constructor(props) {
        super(props);

        this.state = {
            data: [],
            excelData: [],
            report: 1,
            academicYear: null,
            semester: null,
            orgUnit: null,

            studyProgramBasics: [],
            studyProgramBasicId: null,
            results: [],
            loader: false,
            reportRequested: false,

            orgUnitFilter: shouldShowOrgUnitFilter(localStorage.getItem('activeRole')),


        };

        this.getResults = this.getResults.bind(this);
        this.getDataToRender = this.getDataToRender.bind(this);
        this.handleInputChange = this.handleInputChange.bind(this);
    }
    componentDidMount() {
        let activeRole = localStorage.getItem('activeRole');
        if (localStorage.getItem('orgUnit')) {
            this.setState({ orgUnit: parseInt(localStorage.getItem('orgUnit')) });
            localStorage.setItem('activeRole', activeRole);
        }

        if (localStorage.getItem('orgUnit')) {
            let orgUnit = localStorage.getItem('orgUnit');
            window.localStorage.clear();
            localStorage.setItem('orgUnit', orgUnit);
            localStorage.setItem('activeRole', activeRole);
        }
        localStorage.setItem('activeRole', activeRole);
        this.getSPB();
    }


    getSPB(orgUnitId) {
        const orgUnit = orgUnitId || this.state.orgUnit || localStorage.getItem('orgUnit');
        const url = this.state.orgUnitFilter
            ? (orgUnit ? `study-programs/basic/${orgUnit}` : 'study-programs/basic/all')
            : 'study-programs/basic';

        let obj = {};
        axios.post(url, { ...obj })
            .then(res => {
                const studyProgramBasics = res.data.map((el) => ({
                    ...el,
                    value: el.studyProgramBasic.id,
                    key: el.studyProgramBasic.id,
                    text: el.studyProgramBasic.name + (el.studyProgramBasic.comment !== null ? ' (' + el.studyProgramBasic.comment + ')' : ''),
                    description: this.state.orgUnitFilter ? el.organizationalUnit.name : el.studyProgramBasic.studyCycles.length ? el.studyProgramBasic.studyCycles[0].displayName : ''
                })).filter(e => e.studyProgramBasic.archived === false);

                this.setState({ studyProgramBasics });
            })
            .catch(err => {
                console.log('Failed to fetch study program basics. ', err);
            });
    }

    handleInputChange(event, { name, value }) {
        if (name === 'orgUnit') {
            const url = value ? `study-programs/basic/${value}` : 'study-programs/basic/all';
            let obj = {};
            axios.post(url, { ...obj })
                .then(res => {
                    const studyProgramBasics = res.data.map((el) => ({
                        ...el,
                        value: el.studyProgramBasic.id,
                        key: el.studyProgramBasic.id,
                        text: el.studyProgramBasic.name + (el.studyProgramBasic.comment !== null ? ' (' + el.studyProgramBasic.comment + ')' : ''),
                        description: this.state.orgUnitFilter ? el.organizationalUnit.name : el.studyProgramBasic.studyCycles.length ? el.studyProgramBasic.studyCycles[0].displayName : ''
                    })).filter(e => e.studyProgramBasic.archived === false);

                    this.setState({ studyProgramBasics });
                })
                .catch(err => {
                    console.log('Failed to fetch study program basics. ', err);
                });
        }


        this.setState({
            [name]: value,
            results: [],
            data: [],
            excelData: [],
            loader: false,
            reportRequested: false
        }, () => {
            if (name === 'orgUnit') {
                this.setState({ studyProgramBasicId: null, results: [] });
            }
        });
    }

    getData(studyProgramBasicId = -1, archived = -1, orgUnit = this.state.orgUnit) {
        const organizationalUnitId = orgUnit || -1;

        this.setState({ loader: true, reportRequested: true });
        axios.get(this.state.orgUnitFilter ? `reports/number-of-students-per-study-cycle/${organizationalUnitId}/${studyProgramBasicId}`
            : `reports/number-of-students-per-study-cycle/${studyProgramBasicId}`, {
            params: this.state.academicYear ? { academicYearId: this.state.academicYear } : {}
        })
            .then(res => {
                this.setState({
                    loader: false,
                    data: res.data,
                    excelData: res.data.map(el => ([
                        { value: el.studyCycleName },
                        { value: el.numberOfStudents }
                    ]))
                });
                console.log('data', this.state.data);
            });
    }

    getResults(results) {
        if (results.length === 0) {
            this.setState({
                excelData: this.state.data.map(el => ([
                    { value: el.studyCycleName },
                    { value: el.numberOfStudents },
                ]))
            });
        } else {
            this.setState({
                results,
                excelData: results.map(el => ([
                    { value: el.studyCycleName },
                    { value: el.numberOfStudents },
                ]))
            });
        }
    }

    getDataToRender() {
        if (this.state.results.length !== 0) {
            return this.state.results;
        }
        return this.state.data;
    }

    render() {
        const multiDataSet = [
            {
                columns: [
                    { title: 'Ciklus', width: { wpx: 200 } },
                    { title: 'Broj studenata', width: { wpx: 200 } },
                ],
                data: this.state.excelData,
            }
        ];
        const {
            data, loader, reportRequested
        } = this.state;
        return (
            <div>
                <Form>
                    <Segment style={additionalFilterSectionStyle}>
                        <Header as="h4" color="blue">Dodatni filteri</Header>
                        <Form.Group widths="equal" style={filterFieldGridStyle}>
                            <Form.Field>
                                <Form.Dropdown
                                    clearable
                                    label="Akademska godina"
                                    placeholder="Sve akademske godine"
                                    value={this.state.academicYear}
                                    onChange={this.handleInputChange}
                                    name="academicYear"
                                    options={this.props.academicYears || []}
                                    search
                                    fluid
                                    selection
                                />
                            </Form.Field>
                            {this.state.orgUnitFilter && <Form.Field>
                                <Form.Dropdown
                                    clearable
                                    label="Organizaciona jedinica"
                                    placeholder="Organizaciona jedinica"
                                    value={this.state.orgUnit}
                                    onChange={this.handleInputChange}
                                    name="orgUnit"
                                    options={this.props.organizationalUnits}
                                    search
                                    fluid
                                    selection
                                    error={this.state.organizationalUnitEntityError}
                                />
                            </Form.Field>}
                            <Form.Field>
                                <Form.Dropdown
                                    label="Studijski program"
                                    clearable
                                    placeholder="Odaberite studijski program"
                                    options={this.state.studyProgramBasics}
                                    onChange={this.handleInputChange}
                                    name="studyProgramBasicId"
                                    value={this.state.studyProgramBasicId}
                                    search
                                    fluid
                                    selection
                                />
                            </Form.Field>
                        </Form.Group>
                    </Segment>
                    <Button basic="true" color="blue" floated="right" onClick={this.props.closeReport}>
                        Odustani
                    </Button>
                    <Button
                        color="blue"
                        floated="right"
                        onClick={() => this.getData(this.state.studyProgramBasicId ? this.state.studyProgramBasicId : -1)}
                    >
                        Prikaži izvještaj
                    </Button>
                </Form>

                <br /><br /><br />

                {loader ? <div><Loader active inline="centered" > Učitavanje podataka može potrajati, molimo da sačekate.</Loader><br /><br /><br /></div>
                    :
                    <div>

                    {reportRequested && data.length ? <Table celled selectable compact>

                            <Table.Header>
                            <Table.Row>
                                    <Table.HeaderCell colSpan={5} >
                                    <Grid column={2} stackable>
                                            <Grid.Column width={14}>
                                            <SearchTableData profMozilla data={this.state.data} getResults={this.getResults} filterItem={['studyCycleName']} />
                                        </Grid.Column>
                                            <Grid.Column width={2} textAlign="center">
                                            <ReportExcelFile
                                                    filename="Ukupan broj studenata po ciklusu"
                                                    element={<Popup
                                                        trigger={<Button animated="vertical" color="green" basic floated="right" fluid style={{ textAlign: 'center' }}>
                                                            <Button.Content hidden> <Icon name="download" /></Button.Content>
                                                            <Button.Content visible>
                                                                Excel
                                                            </Button.Content>
                                                        </Button>}
                                                        content="Preuzmi spisak u Excel-u"
                                                        hideOnScroll
                                                        position="top center"
                                                    />}
                                                >
                                                    <ExcelSheet dataSet={sanitizeExcelDataSet(multiDataSet)} name="Studenti" />
                                                </ReportExcelFile>

                                        </Grid.Column>
                                        </Grid>
                                </Table.HeaderCell>
                                </Table.Row>
                            <Table.Row>
                                    <Table.HeaderCell width="1">  R.br. </Table.HeaderCell>
                                    <Table.HeaderCell colSpan={2}>Ciklus</Table.HeaderCell>
                                    <Table.HeaderCell colSpan={2}> Broj studenata </Table.HeaderCell>

                                </Table.Row>
                        </Table.Header>
                            <Table.Body> {data.map((el, index) =>
                                (<Table.Row key={el.id}>

                                    <Table.Cell verticalAlign="middle" width="1">  {index + 1}. </Table.Cell>
                                    <Table.Cell colSpan={2} verticalAlign="middle" > {el.studyCycleName}</Table.Cell>
                                    <Table.Cell colSpan={2} verticalAlign="middle" > {el.numberOfStudents}</Table.Cell>

                                </Table.Row>))}
                        </Table.Body>
                        </Table> : reportRequested ? 'Nema podataka.' : null}
                </div>


                }

            </div>
        );
    }
}

export default StudentsPerCycle;



// WEBPACK FOOTER //
// ./src/views/StudentService/StudentsReports/StudentsPerCycle.js